export const NEXT_PUBLIC_ENV = process.env.NEXT_PUBLIC_ENV;
export const NEXT_PUBLIC_CDN_URL = process.env.NEXT_PUBLIC_CDN_URL;
export const NEXT_PUBLIC_COURSE_API_URL = process.env.NEXT_PUBLIC_COURSE_API_URL;
export const NEXT_PUBLIC_INTERNAL_COURSE_API_URL = process.env.NEXT_PUBLIC_INTERNAL_COURSE_API_URL;
export const NEXT_PUBLIC_SITE_URL = process.env.NEXT_PUBLIC_SITE_URL;
export const NEXT_PUBLIC_RALLIT_SITE_URL = process.env.NEXT_PUBLIC_RALLIT_SITE_URL;
export const NEXT_PUBLIC_ANT_MAN_URL = process.env.NEXT_PUBLIC_ANT_MAN_URL;
export const NEXT_PUBLIC_MIXPANEL_TOKEN = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN;
export const NEXT_PUBLIC_ACCOUNT_API_URL = process.env.NEXT_PUBLIC_ACCOUNT_API_URL;
export const NEXT_PUBLIC_INTERNAL_ACCOUNT_API_URL =
  process.env.NEXT_PUBLIC_INTERNAL_ACCOUNT_API_URL;
export const NEXT_PUBLIC_HACKLE_CLIENT_KEY = process.env.NEXT_PUBLIC_HACKLE_CLIENT_KEY;
export const NEXT_PUBLIC_HACKLE_SERVER_KEY = process.env.NEXT_PUBLIC_HACKLE_SERVER_KEY;
export const NEXT_PUBLIC_SERVER_MOCK_API_BASE_URL =
  process.env.NEXT_PUBLIC_SERVER_MOCK_API_BASE_URL;
export const NEXT_PUBLIC_COMMIT_HASH = process.env.NEXT_PUBLIC_COMMIT_HASH;
export const NEXT_PUBLIC_VERSION = process.env.NEXT_PUBLIC_VERSION;
export const NEXT_PUBLIC_DATADOG_CLIENT_TOKEN = 'pubba81abeb82534976f298f54d286f9c47';
export const NEXT_PUBLIC_DATADOG_APP_ID = 'a321fe62-4c8b-4f29-814f-b9a8f40ed7f2';
export const NEXT_PUBLIC_USE_MSW = process.env.NEXT_PUBLIC_USE_MSW || 'false';
export const NEXT_PUBLIC_DATADOG_SERVICE = 'inflearn-next-fe';
export const NEXT_PUBLIC_ANT_MAN_ACCOUNT_API_URL = process.env.NEXT_PUBLIC_ANT_MAN_ACCOUNT_API_URL;
export const NEXT_PUBLIC_UCC_API_URL = process.env.NEXT_PUBLIC_UCC_API_URL;
export const NEXT_PUBLIC_INTERNAL_UCC_API_URL = process.env.NEXT_PUBLIC_INTERNAL_UCC_API_URL;
export const NEXT_PUBLIC_DATADOG_ENV = process.env.NEXT_PUBLIC_DATADOG_ENV;
export const NEXT_PUBLIC_SHORT_URL_DOMAIN = process.env.NEXT_PUBLIC_SHORT_URL_DOMAIN;
export const NEXT_PUBLIC_INFLEARN_HOST = process.env.NEXT_PUBLIC_INFLEARN_HOST;
export const NEXT_PUBLIC_BUSINESS_HOST = process.env.NEXT_PUBLIC_BUSINESS_HOST;
export const NEXT_PUBLIC_RALLIT_HOST = process.env.NEXT_PUBLIC_RALLIT_HOST;
export const NEXT_PUBLIC_RALLIT_API_URL = process.env.NEXT_PUBLIC_RALLIT_API_URL;
export const NEXT_PUBLIC_INTERNAL_RALLIT_API_URL = process.env.NEXT_PUBLIC_INTERNAL_RALLIT_API_URL;
export const NEXT_PUBLIC_ADMIN_HOST = process.env.NEXT_PUBLIC_ADMIN_HOST;
export const NEXT_PUBLIC_CHANNEL_PLUGIN_KEY = process.env.NEXT_PUBLIC_CHANNEL_PLUGIN_KEY || '';
export const NEXT_PUBLIC_CHANNEL_WEBHOOK_INIT_TOKEN =
  process.env.NEXT_PUBLIC_CHANNEL_WEBHOOK_INIT_TOKEN || '';
export const NEXT_PUBLIC_CDN_INTEGRATED_HOST = process.env.NEXT_PUBLIC_CDN_INTEGRATED_HOST || '';
export const NEXT_PUBLIC_CAPTCHA_SITE_KEY = process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY || 'asdf';
export const NEXT_PUBLIC_SUPPORT_EMAIL = process.env.NEXT_PUBLIC_SUPPORT_EMAIL;
export const NEXT_PUBLIC_MENTORING_API_URL = process.env.NEXT_PUBLIC_MENTORING_API_URL;
export const NEXT_PUBLIC_INTERNAL_MENTORING_API_URL =
  process.env.NEXT_PUBLIC_INTERNAL_MENTORING_API_URL;
export const NEXT_PUBLIC_MENTORING_SITE_URL = process.env.NEXT_PUBLIC_MENTORING_SITE_URL;
export const NEXT_PUBLIC_PAYMENT_API_URL = process.env.NEXT_PUBLIC_PAYMENT_API_URL;
export const NEXT_PUBLIC_INTERNAL_PAYMENT_API_URL =
  process.env.NEXT_PUBLIC_INTERNAL_PAYMENT_API_URL;
export const NEXT_PUBLIC_DEVOPS_API_URL = process.env.NEXT_PUBLIC_DEVOPS_API_URL || '';
export const NEXT_PUBLIC_CLARITY_PROJECT_ID = process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID;
export const NEXT_PUBLIC_EVENT_SITE_URL = process.env.NEXT_PUBLIC_EVENT_SITE_URL;
